import React from "react";
import CardItem from "./CardItem";
import { Button } from "./Button";
import "./CardPortfolio.css";
import { Link } from "react-router-dom";
import PortfolioItem from "./PortfolioItem";

function CardPortfolio() {
  return (
    <div className="portfolio-container">
      <h1>Our Work</h1>
      <p>
        We’ve poured our passion and expertise into creating high-end real
        estate media experiences. Through photography, videography, aerial drone
        footage, and immersive 360° tours, we deliver unique visual solutions
        that bring properties to life. From modern condos in Montreal to luxury
        estates beyond.
      </p>

      <div className="portfolio-img">
        <Link to="/portfolio?filter=360" className="navbar-logo">
          <PortfolioItem
            src="images/360-icon.png"
            title="360° VIRTUAL TOURS"
          ></PortfolioItem>
        </Link>
        <Link to="/portfolio?filter=Video" className="navbar-logo">
          <PortfolioItem
            src="images/2.png"
            title="CINEMATICS  TOURS"
          ></PortfolioItem>
        </Link>
        <Link to="/portfolio?filter=Drone" className="navbar-logo">
          <PortfolioItem
            src="images/1.png"
            title="DRONE FOOTAGE"
          ></PortfolioItem>
        </Link>
        <Link to="/portfolio?filter=Photo" className="navbar-logo">
          <PortfolioItem src="images/3.png" title="PHOTOGRAPHY"></PortfolioItem>
        </Link>
      </div>
      <br></br>
      <div className="buttons">
        <Link to="/portfolio">
          <Button
            className="btn-mobile"
            buttonStyle="btn--primary"
            buttonSize="btn--large"
          >
            Discover Projects
          </Button>
        </Link>
      </div>
    </div>
  );
}
export default CardPortfolio;
